export const OTP_TOKEN_LOGIN_START = "OTP_TOKEN_LOGIN_START";
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
